<template>
  <div>
      <tplheader></tplheader>
      <tplLeftPanel></tplLeftPanel>
    <form>
      <div id="fixed-top-menu-outer" class="fixed-top-menu-outer">
        <div class="fixed-top-menu">
          <div class="pull-right">
            <button class="btn btn-primary" type="button" v-on:click="ment"><i class="fa fa-sign-in"></i>mentés</button>
          </div>
        </div>
      </div>
      <div id="main-panel" class="main-panel">
        <div class="content-panel">
          <ul class="breadcrumb">
            <li>Kezdőőoldal</li>
            <li><a href="#" class="active">Teszt</a></li>
          </ul>
          <div class="page-title">
            <h1><i class="material-icons">chevron_right</i>Teszt</h1>
          </div>
          <div class="content-panel-top-btn-group">
            <button class="btn btn-primary" type="button" v-on:click="ment"><i class="fa fa-sign-in"></i>mentés</button>
          </div>
          <div class="panel">
            <div class="panel-heading">
              <h4>Teszt</h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12">
                    <inputbox id="mezo1" label="Mező1" v-bind:errors="errors" name="mezo1" v-model="form.mezo1"></inputbox>
                    <combobox id="mezo2" label="Mező2" v-bind:errors="errors" name="mezo2" v-model="form.mezo2"></combobox>
                    <checkbox id="mezo3" label="Mező3" v-bind:errors="errors" name="mezo3" v-model="form.mezo3"></checkbox>
                    <toggle id="mezo4" label="Mező4" v-bind:errors="errors" name="mezo4" v-model="form.mezo4"></toggle>
                    <checkboxes id="mezo5" label="Mező5" v-bind:errors="errors" name="mezo5" v-model="form.mezo5"></checkboxes>
                    <radios id="mezo6" label="Mező6" v-bind:errors="errors" name="mezo6" v-model="form.mezo6"></radios>
                    <select2 multi="true" id="mezo7" label="Mező7" v-bind:errors="errors" name="mezo7" v-model="form.mezo7"></select2>

                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Név</th>
                          <th>Email</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="admin in adminok">
                          <td>{{admin.id}}</td>
                          <td>{{admin.username}}</td>
                          <td>{{admin.email}}</td>
                          <td>
                            <ul class="icon-list">
                              <li class="dropdown"><a class="dropdown-toggle" href="javascript:void(0)"><i class="fa fa-gear"></i></a>
                                <ul class="dropdown-menu">
                                  <li class="dropdown-header">Opciók</li>
                                  <li><a v-on:click="szerkeszt(admin.id)" href="javascript:void(0)"><i class="fa fa-pencil-square-o"></i>Szerkeszt</a></li>
                                  <li><a v-on:click="torol(admin.id)" href="javascript:void(0)"><i class="fa fa-trash"></i>Töröl</a></li>
                                </ul>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>
<script>
import tplheader from './tpl_header.vue';
import tplLeftPanel from './tpl_leftpanel.vue';

export default {
  components: {
    tplheader,
    tplLeftPanel
  },
  data: function() {
    return {
      form: {
        mezo1: '',
        mezo2: '',
        mezo3: '',
        mezo4: '',
        mezo5: '',
        mezo6: '',
        mezo7: {
          items: [],
          selected: []
        }
      },
      adminok: [],
      errors: [
      ]
    }
  },
  mounted: function() {
    var _this = this;

    this.form.mezo1 = this.$route.query.userID;

    this.$root.ajax('test/index', {
      method: 'POST',
      success: function(response) {
        _this.form.mezo2 = response.mezo2;
        _this.form.mezo3 = response.mezo3;
        _this.form.mezo4 = response.mezo4;
        _this.form.mezo5 = response.mezo5;
        _this.form.mezo6 = response.mezo6;
        _this.form.mezo7 = response.mezo7;
        _this.adminok = response.adminok;
      }
    });
  },
  methods: {
    ment: function (event) {
      var _this = this;

      this.$root.ajax('test/save', {
        method: 'POST',
        data: this.form,
        success: function(response) {
        }
      });
    },
    szerkeszt: function(id) {
      alert("Szerkeszt:"+id);
    },
    torol: function(id) {
      alert("Töröl:"+id);
    }
  }
}
</script>


// WEBPACK FOOTER //
// test.vue?85259f12